module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.debugPanel)+'" data-playable-component> <div class="'+(props.styles.closeButton)+'" data-playable-hook="debug-panel-close-button" > x </div> <pre class="'+(props.styles.infoContainer)+'" data-playable-hook="debug-panel-info-container" > </pre></div>';return out;
} 
  };